import React from "react";

const faqData = [
  {
    id: 0,
    q: (
      <div>
        What are
        <h2 className="inline font-body ml-[0.5ch] text-2sm md:text-base">
          Vendor Payments
        </h2>
        ?
      </div>
    ),
    a: (
      <>
        <p>
          Vendor Payments are the payments made against invoices received by a
          business during the course of its operations, this becomes a
          significant part of total account payables for a business. Some
          examples of vendor payments include payments against invoices raised
          by supplier or vendor of goods and services, charges for using
          services like AWS, email automation service etc.
        </p>
        <p>
          Cashfree Payments has built Vendor Payments as an advanced solution to
          help businesses streamline all accounts payables including vendor
          invoices, utility bills etc. Just upload the invoice and let us manage
          all your invoice payments on one platform and reconcile with your
          accounting platform.
        </p>
      </>
    ),
  },
  {
    id: 1,
    q: "Why should I use the Vendor Payments solution by Cashfree Payments? ",
    a: (
      <p>
        As of October 2022, e-invoicing is compulsory for all business to
        business transactions for businesses with an annual turnover exceeding
        10 crore rupees. Cashfree Payments provides you with an interface as a
        solution to process your accounts payable. You can now pay your vendors
        by uploading invoices in bulk or one at a time
      </p>
    ),
  },
  {
    id: 2,
    q: "What are the charges for using the feature Vendor Payments?",
    a: (
      <p>
        You can avail the introductory offer by signup up here and use the
        Vendor Payments solution at zero additional cost. Standard Payouts
        charges apply. This offer is also available for existing Cashfree
        Payments merchants.
      </p>
    ),
  },
  {
    id: 3,
    q: "How to manage multiple vendor invoices?",
    a: (
      <>
        <p>
          Managing multiple vendor payments is simple. You get flexibility to
          upload invoices individually or in bulk. You can track all the
          invoices at a place based on their due date.{" "}
          <a
            href="https://docs.cashfree.com/docs/invoices-payouts#upload-bulk-invoices"
            className="external-link text-cf-green"
            target="_blank"
            rel="noreferrer">
            Click here
          </a>{" "}
          to know more.
        </p>
        <p>
          {" "}
          Further using Cashfree Payments you can can track all their vendor
          payments at once place.
        </p>
      </>
    ),
  },
  {
    id: 4,
    q:
      "What types of bills can be managed with Cashfree's Vendor Payments platform?",
    a: (
      <>
        <p>
          Cashfree&apos;s Vendor Payments platform supports bills including and
          not limited to Vendor bills, BBPS bills, and GST Payments [Beta]. You
          can easily upload, approve, and pay these bills using the platform.
        </p>
      </>
    ),
  },
  {
    id: 5,
    q: "How can I upload my invoices?",
    a: (
      <>
        <p>
          You can upload your invoices easily by using the invoice upload
          feature provided by Cashfree. You can either upload a single invoice
          or perform a bulk upload of multiple invoices. You can follow the
          steps here to upload your invoices:&nbsp;
          <a
            href="https://docs.cashfree.com/docs/invoices-payouts#pay-invoices"
            className="external-link text-cf-green"
            target="_blank"
            rel="noreferrer">
            Documentation
          </a>
        </p>
      </>
    ),
  },
  {
    id: 6,
    q:
      "Does Cashfree's Vendor Payments platform integrate with accounting tools like Tally?",
    a: (
      <>
        <p>
          Yes, Cashfree&apos;s Vendor Payments platform seamlessly synchronizes
          account payables from Tally and other accounting tools. This
          integration enables efficient management of invoices and payments.
        </p>
      </>
    ),
  },
  {
    id: 7,
    q: "What payment methods are supported for invoice payments?",
    a: (
      <>
        <p>
          Cashfree Invoices & Payouts supports multiple payment methods,
          including credit/debit cards, net banking, UPI (Unified Payments
          Interface), and wallets. Customers can choose their preferred payment
          method to settle the invoice.
        </p>
      </>
    ),
  },
  {
    id: 8,
    q: "How can I track the status of my invoices?",
    a: (
      <>
        <p>
          You can easily track the status of your invoices through the Cashfree
          Dashboard. It provides real-time updates on the payment status,
          including whether an invoice is pending, paid, or overdue. You can
          also receive automated notifications for invoice activities.
        </p>
      </>
    ),
  },
  {
    id: 9,
    q: "Can I send reminders to customers for overdue invoices?",
    a: (
      <>
        <p>
          Yes, Cashfree Invoices & Payouts allows you to send automated
          reminders to customers for overdue invoices by selecting the ‘due
          date’ option.. You can set up reminders to be sent at specific
          intervals and customize the content of the reminder emails.&nbsp;
          <a
            className="external-link text-cf-green"
            href="https://docs.cashfree.com/docs/invoices-payouts#pay-invoices"
            target="_blank"
            rel="noreferrer">
            Read More
          </a>
        </p>
      </>
    ),
  },
];

export default faqData;
